import React from 'react';
import { motion } from 'framer-motion';
export function ProductPresentation() {
  return <section className="py-16 md:py-24 px-4 bg-bg-primary" data-id="element-226">
      <div className="max-w-4xl mx-auto text-center" data-id="element-227">
        <motion.h2 className="font-heading text-4xl md:text-5xl font-bold text-heading mb-6" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-228">
          Candidiasis Vaginal: Lo Que Debes Saber
        </motion.h2>

        <motion.p className="text-xl text-body mb-12 max-w-3xl mx-auto leading-relaxed" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} data-id="element-229">
          La guía premium de salud íntima femenina que te da toda la información
          que necesitas, organizada, clara y lista para aplicar
        </motion.p>

        <motion.div className="flex justify-center" initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} data-id="element-230">
          <div className="relative" data-id="element-231">
            <div className="absolute inset-0 bg-gradient-to-br from-accent-blush to-accent-lilac rounded-2xl blur-2xl opacity-30 transform rotate-3" data-id="element-232"></div>
            <img src="https://cdn.magicpatterns.com/uploads/84z9jJx341cntZP33FYa8v/thumb.png" alt="Candidiasis Vaginal: Lo Que Debes Saber - Portada de la guía" className="relative w-full max-w-md mx-auto rounded-2xl shadow-2xl transform hover:scale-105 transition-transform duration-300" data-id="element-233" />
          </div>
        </motion.div>
      </div>
    </section>;
}